import { Button } from 'antd';
import React from 'react';
import { useForm, withForm } from 'react-antd-formutil';
import { useNavigate } from 'react-router-dom';
import { CardButtonWrap } from 'components/Card';
import Toast from 'components/Toast';
import VerifyCodeSend from 'components/VerifyCodeSend';
import security from 'stores/security';
import API from 'utils/API';
import http from 'utils/http';

/**
 *  激活邮箱-验证邮箱
 */
const Confirm: React.FC = () => {
    const $formutil = useForm();
    const navigate = useNavigate();

    const submit = async () => {
        const { $invalid, $batchDirty, $getFirstError, $params } = $formutil;

        if ($invalid) {
            Toast.show($getFirstError());
            $batchDirty(true);
        } else {
            try {
                Toast.loading(true);
                await http.post(API.OAUTH.setEmail(), $params);
                await security.getStatus();

                navigate('../2');
            } catch (err) {
                Toast.show(err);
            }

            Toast.loading(false);
        }
    };

    return (
        <div>
            <p>
                {__('用户邮箱')}：{security.userInfo?.email}
            </p>
            <VerifyCodeSend type="email" username={security.userInfo?.email || ''} process="bind_email" logined />
            <CardButtonWrap>
                <Button type="primary" size="large" block onClick={submit} className="btn-next">
                    {__('下一步')}
                </Button>
            </CardButtonWrap>
        </div>
    );
};

export default withForm(Confirm);
